<template>
  <v-row id="notificationSettings">
    <v-col md="12" cols="12" class="pa-0">
      <v-card flat tile>
        <v-card-text>
          <v-item-group>
            <!-- Marketing Services -->
            <v-item>
              <v-card flat tile class="text-center text-md-left">
                <v-card-title class="justify-center justify-md-start body-heading-medium px-0">Marketing Services</v-card-title>
                <v-card-text class="px-0">
                  <v-row>
                    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start py-0">
                      <v-list-item two-line class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="body-heading-small">Easi News and Promotions</v-list-item-title>
                          <v-list-item-subtitle class="body-text-small">News, promotions and events for you</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
                      <v-row>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center">
                          <v-checkbox v-model="newNotificationSettings.news_and_promo.email" label="Email" @change="onNotificationSettingsChange" />
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center">
                          <v-checkbox v-model="newNotificationSettings.news_and_promo.sms" label="SMS" @change="onNotificationSettingsChange" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-item>
            <!-- Quest Reminder -->
            <v-item>
              <v-card flat tile class="text-center text-md-left">
                <v-card-title class="justify-center justify-md-start body-heading-medium px-0">Quest Reminder</v-card-title>
                <v-card-text class="px-0">
                  <v-row>
                    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start py-0">
                      <v-list-item two-line class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="body-heading-small">Completed Quests</v-list-item-title>
                          <v-list-item-subtitle class="body-text-small">Never miss your kid's completed quests</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
                      <v-row>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center">
                          <v-checkbox v-model="newNotificationSettings.completed_quests.email" label="Email" @change="onNotificationSettingsChange" />
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center">
                          <v-checkbox v-model="newNotificationSettings.completed_quests.sms" label="SMS" @change="onNotificationSettingsChange" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-item>
            <!-- Points -->
            <v-item>
              <v-card flat tile class="text-center text-md-left">
                <v-card-title class="justify-center justify-md-start body-heading-medium px-0">Points</v-card-title>
                <v-card-text class="px-0">
                  <v-row>
                    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start py-0">
                      <v-list-item two-line class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="body-heading-small">Low Points Alert</v-list-item-title>
                          <v-list-item-subtitle class="body-text-small">You want to receive low point balance alert</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
                      <v-row>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center">
                          <v-checkbox v-model="newNotificationSettings.low_points.email" label="Email" @change="onNotificationSettingsChange" />
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center">
                          <v-checkbox v-model="newNotificationSettings.low_points.sms" label="SMS" @change="onNotificationSettingsChange" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-item>
            <v-row v-if="hasNotificationSettingsChanged">
              <v-col cols="12" md="12" class="d-flex justify-md-end justify-center">
                <v-btn @click="cancel" text color="secondary" class="ma-2">
                  Cancel
                </v-btn>
                <v-btn @click="updateNotificationSettings" color="secondary" class="ma-2">
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-item-group>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "NotificationSettings",
    data() {
      return {
        notificationSettings: {},
        newNotificationSettings: {
          news_and_promo: { email: undefined, sms: undefined },
          completed_quests: { email: undefined, sms: undefined },
          low_points: { email: undefined, sms: undefined },
        },
        hasNotificationSettingsChanged: false,
      };
    },
    methods: {
      onNotificationSettingsChange() {
        this.hasNotificationSettingsChanged = true;
      },

      updateNotificationSettings() {
        this.$http
          .put("/parents", { notification_settings: this.newNotificationSettings })
          .then((response) => {
            this.$store.commit("setUserInfo", response.data.parent);
            this.hasNotificationSettingsChanged = false;
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Could not update user's notification settings, please try again later",
              type: "error",
            });
            this.hasNotificationSettingsChanged = false;
            this.$store.commit("setLoadingStatus", false);
          });
      },

      cancel() {
        this.newNotificationSettings = this.$formatter.extend(this.notificationSettings);
        this.hasNotificationSettingsChanged = false;
      },
    },
    created() {
      this.$http
        .get("/profile")
        .then((response) => {
          if (response && response.data && response.data.profile && response.data.profile.notification_settings) {
            this.notificationSettings = this.$formatter.merge({}, response.data.profile.notification_settings);
            this.newNotificationSettings = this.$formatter.extend(response.data.profile.notification_settings);
          } else {
            this.$store.commit("setError", {
              message: "Could not retrieve user's notification settings information, please try again later",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setError", {
            message: "Could not retrieve user's notification settings information, please try again later",
            type: "error",
          });
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GeneralSettings/NotificationSettings.vue